import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { I18NextPipe } from 'angular-i18next';

import { usersService } from 'src/app/services/services/users.service';
import { DialogHelpComponent } from 'src/app/common/dialogs/dialog-help/dialog-help.component';
import { LogsSettingsModel } from '../models';
import { finalize } from 'rxjs';

@Component({
    selector: 'app-userlogs',
    templateUrl: './userlogs.component.html',
    styleUrls: ['./userlogs.component.scss'],
    standalone: false
})
export class UserLogsComponent implements OnInit, OnDestroy {

  accordionStates = {
    logs: false,
    access: false
  };

  isLoading = true;

  BreadcrumbsLink = [
    { label: 'Home', url: '/' },
    { label: 'Log', url: '/users/user-logs' }
  ];

  logsSettings: LogsSettingsModel | null = null;

  constructor(
    private usersService: usersService,
    private dialog: MatDialog,
    private i18n: I18NextPipe
  ) { }

  async ngOnInit(): Promise<void> {
    this.usersService.GetLogsSettings()
     .pipe(finalize(() => this.isLoading = false))
      .subscribe(settings => {
      this.logsSettings = settings;
    });
  }

  ngOnDestroy(): void { }

  toggleAccordion(type: 'logs' | 'access'): void {
    this.accordionStates[type] = !this.accordionStates[type];
  }

  // convenience getters so template is clean and resilient to casing
  get showChangeLog(): boolean {
    const s: any = this.logsSettings;
    return !!(s && (s.showChangeLog ?? s.ShowChangeLog));
  }

  get showAccessLog(): boolean {
    const s: any = this.logsSettings;
    // note: original MVC used ShowAcessLog (typo), so we check both
    return !!(s && (s.showAccessLog ?? s.ShowAcessLog));
  }

  get modulesModel(): any {
    const s: any = this.logsSettings;
    return s?.modulesModel ?? s?.ModulesModel ?? null;
  }

  // --- HELP DIALOG ---
  openHelp(): void {
    this.dialog.open(DialogHelpComponent, {
      panelClass: 'dialog-help-pannel',
      backdropClass: 'backdrop-invisible',
      width: '600px',
      data: {
        title: this.i18n.transform('users:help_title_userslog', { defaultValue: 'User logs help' }),
        text: this.i18n.transform('users:help_userslog', { defaultValue: '' }),
        renderAsHtml: true
      }
    });
  }
}
